// Small status badges shared by the Individual Activity table and detail.
import React from "react";

export const StatusBadge = ({ status, t }) => {
  const map = {
    online: ["is-online", t("sOnline", "Online")],
    offline: ["", t("sOffline", "Offline")],
    restricted: ["is-restricted", t("sRestricted", "Restricted")],
    blocked: ["is-blocked", t("sBlocked", "Blocked")],
  };
  const [cls, label] = map[status] || map.offline;
  return <span className={`ia-badge ${cls}`}>{status === "online" && <i aria-hidden="true" />}{label}</span>;
};

export const TypeBadge = ({ type, t }) => {
  const label = { anonymous: t("vAnonymous", "Anonymous"), authenticated: t("vAuthenticated", "Signed in"), signed_out: t("vSignedOut", "Signed out") }[type] || type;
  return <span className={`ia-badge type-${type}`}>{label}</span>;
};

export const RiskBadge = ({ level, t }) => (
  level && level !== "NONE"
    ? <span className={`ia-badge risk-${level}`}>{t(`risk${level}`, { LOW: "Low", MEDIUM: "Medium", HIGH: "High", CRITICAL: "Critical" }[level] || level)}</span>
    : <span className="live-muted">{t("riskNone", "None")}</span>
);
